import { styled } from '@linaria/react'
import React, { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import FirstSlideImg from '../svgr/OnboardingSlide1'
import SecondSlideImg from '../svgr/OnboardingSlide2'
import ThirdSlideImg from '../svgr/OnboardingSlide3'
import { colors } from '../styles/colors'

const OnboardingSlide: FC<{
  data: {
    title: ReactNode
    subtitle: ReactNode
  }

  imageComponent: React.ReactNode
}> = ({ data, imageComponent }) => (
  <SlideContent>
    <ImageContainer>{imageComponent}</ImageContainer>

    <TextContent>
      <Typography fontSize={20} fontWeight={700} color={colors.textPrimary}>
        {data.title}
      </Typography>

      <Typography fontSize={14} fontWeight={400} color={colors.textPrimary}>
        {data.subtitle}
      </Typography>
    </TextContent>
  </SlideContent>
)

export const OnboardingSlide1: FC = () => (
  <OnboardingSlide
    data={{
      title: (
        <FormattedMessage
          id="onboarding.slide1.title"
          defaultMessage="Выбирай и отдавай голос"
        />
      ),
      subtitle: (
        <FormattedMessage
          id="onboarding.slide1.subtitle"
          defaultMessage="Победители получают свои TON плюс долю от проигравших"
        />
      ),
    }}
    imageComponent={<FirstSlideImg />}
  />
)

export const OnboardingSlide2: FC = () => (
  <OnboardingSlide
    data={{
      title: (
        <FormattedMessage
          id="onboarding.slide2.title"
          defaultMessage="Создавай свои боксы"
        />
      ),
      subtitle: (
        <FormattedMessage
          id="onboarding.slide2.subtitle"
          defaultMessage="Обычный спор или платное голосование, где участники могут поддержать вашу идею"
        />
      ),
    }}
    imageComponent={<SecondSlideImg />}
  />
)

export const OnboardingSlide3: FC = () => (
  <OnboardingSlide
    data={{
      title: (
        <FormattedMessage
          id="onboarding.slide3.title"
          defaultMessage="Приглашай друзей"
        />
      ),
      subtitle: (
        <FormattedMessage
          id="onboarding.slide3.subtitle"
          defaultMessage="Больше друзей - больше голосов - и значит больше заработок"
        />
      ),
    }}
    imageComponent={<ThirdSlideImg />}
  />
)

const SlideContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 300px;
`

const ImageContainer = styled.div`
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
